// Maybe TODO, enforce the correct length and chars of each sub-string
export type Guid = `${string}-${string}-${string}-${string}-${string}`;

export const EmptyGuid: Guid = '00000000-0000-0000-0000-000000000000';

export const GuidsAreEqual = (a: Guid, b: Guid) =>
  a?.toLowerCase() === b?.toLowerCase();
